module.exports = __webpack_public_path__ + "static/media/board_view_campus_img_a.b378fdc8.jpg";